import {useState} from "react";
import {com, space} from "../../provider_api";
import {useRpcSender} from "../RpcSender";
import {RpcState} from "../RpcState";
import GetStripeUrlResponse = com.onkensu.platform.billing.GetStripeUrlResponse;

export const useManageSubscriptionLink = () => {

  const rpcSender = useRpcSender();
  const [rpcState, setRpcState] = useState<RpcState>({state: "none"});
  
  const send = () => {
    setRpcState({state: 'pending'});
    rpcSender.send('get_stripe_provider_dashboard_link', new Uint8Array(0))
        .then(r => {
          let response = GetStripeUrlResponse.decode(r);
          window.location.assign(response.stripeUrl);
        })
        .catch(e => {
          console.log('Error booking.. ', e);
          setRpcState({state: 'error', message: 'Server error booking class!'});
        });
  }

  return {rpcState, send};
}